<template>
  <div class="fixed">
    <b-navbar
      position:sticky
      variant="faded"
      toggleable="lg"
      type="dark"
      class="bg-company-red"
    >
      <b-container>
        <b-navbar-brand>Un Ray</b-navbar-brand>
      </b-container>
    </b-navbar>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/app";
import "firebase/auth";

export default {
  name: "navbarAfilia",
  methods: {
    
  },
};
</script>

<style >
.fixed {
  position: sticky;
  top: 0;
  z-index: 2;
}

.btn-color {
  background: none !important;
  box-shadow: none !important;
  border: none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/navbarAfilia.vue